import { useQuery } from "@tanstack/react-query";
import api from "../../../api/axios";


export const useCustomerInvoiceDetails = (uuid , isEdit) => {
    const { data: invoice, isLoading: invoiceLoading } = useQuery({
        queryKey: ["customer_invoice_fetch", uuid],
        queryFn: async () => {
            const res = await api.get(isEdit ?  `invoice/customer/${uuid}/details` : `invoice/customer/${uuid}/details?exclude_paid=true`);
            return res.data;
        },
        enabled: !!uuid, 
        retry: false,
    });
    
    return { invoices: invoice || [], invoiceLoading: invoiceLoading };
};